"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RespondentTypeSelect = exports.options = void 0;
var react_1 = __importDefault(require("react"));
var footerSelect_1 = require("./footerSelect");
exports.options = [
    { value: 'Företagare', label: 'Företagare' },
    { value: 'Politiker', label: 'Politiker' }
];
exports.RespondentTypeSelect = function (props) {
    return react_1.default.createElement(footerSelect_1.FooterSelect, { disabled: props.disabled, options: exports.options, selectedLabel: props.selectedLabel, onSelectedChange: props.onSelectedChange, menuPlacementTop: props.menuPlacementTop });
};
